var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#FFFFFF",
    strokeWidth: 7.6,
    cx: 79.520318,
    cy: 75.6422261,
    r: 59.5922261
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-3",
    stroke: "#FFFFFF",
    strokeWidth: 7,
    transform: "translate(67.758464, 61.946770) rotate(-90.000000) translate(-67.758464, -61.946770) ",
    points: "51.9584806 49.1700427 51.9584806 74.7234982 83.5584477 74.7234982"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(76.000000, 114.000000)",
    fill: "#000000",
    stroke: "#FFFFFF",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 33.5,
    cy: 14,
    rx: 30,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD",
    transform: "translate(76.000000, 100.000000)",
    fill: "#000000",
    stroke: "#FFFFFF",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5,17.5 L63.5,28 C63.5,29.0602502 62.8596963,29.9997187 61.9772685,30.8900223 C60.5487775,32.3312626 58.4301893,33.5870602 55.8385017,34.6701535 C50.1215805,37.0593146 42.21809,38.5 33.5,38.5 C24.78191,38.5 16.8784195,37.0593146 11.1614983,34.6701535 C8.5698107,33.5870602 6.45122248,32.3312626 5.02273152,30.8900223 C4.14030365,29.9997187 3.5,29.0602502 3.5,28 L3.5,17.5 L63.5,17.5 Z",
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 33.5,
    cy: 14,
    rx: 30,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD-2",
    transform: "translate(76.000000, 86.000000)",
    fill: "#000000",
    stroke: "#FFFFFF",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5,17.5 L63.5,28 C63.5,29.0602502 62.8596963,29.9997187 61.9772685,30.8900223 C60.5487775,32.3312626 58.4301893,33.5870602 55.8385017,34.6701535 C50.1215805,37.0593146 42.21809,38.5 33.5,38.5 C24.78191,38.5 16.8784195,37.0593146 11.1614983,34.6701535 C8.5698107,33.5870602 6.45122248,32.3312626 5.02273152,30.8900223 C4.14030365,29.9997187 3.5,29.0602502 3.5,28 L3.5,17.5 L63.5,17.5 Z",
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD-4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 33.5,
    cy: 14,
    rx: 30,
    ry: 10.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.ba1714aa988b29bee3f394048fdda6a9.svg";
export { ForwardRef as ReactComponent };